import { combineReducers } from "redux";
import axios from "axios";
import UserReducer from "./reducers/UserReducer";
import NotificationReducer from "./reducers/NotificationReducer";

const appReducer = combineReducers({
	userLoginData: UserReducer,
	// notificationsData: NotificationReducer
});

/**
 * create application initial state
 * if user loged out reset all app state
 * @param {object} state - application state
 * @param {oblect} action - action called
 */
export const rootReducer = (state, action) => {
	if (action.type === "USER_LOGGED_OUT") {
		document.querySelector("#body").className = "";
		axios.defaults.headers.common.Authorization = null;
		localStorage.clear();
		state = undefined; // eslint-disable-line no-param-reassign
	}
	return appReducer(state, action);
};

export const mapDispatchToProps = (dispatch) => ({ dispatch });
export const mapStateToProps = (state) => ({ globalState: state });


// WEBPACK FOOTER //
// ./src/RootReducer.js